/* eslint-disable no-template-curly-in-string */
export const cn = {
    title: {
        manageSubscription: '管理订阅',
        pickYourPlan: '选择计划',
        basicUser: '定价方案',
        proUser: '管理订阅',
    },
    subtitle: {
        pickYourPlan: '选择适合您的计划',
        basicUser: '按需选择，找到最适合你的方案',
        proUser: '管理您的订阅',
    },
    recommend: '推荐',
    currentPlan: '当前方案',
    active: '已激活',
    canceled: '已取消',
    changePlan: '切换方案',
    cancelPlan: '取消方案',
    resumePlan: '恢复方案',
    month: '月',
    year: '年',
    flashSale: '闪促 50% OFF',
    billingCycle: {
        monthly: '月付',
        yearly: '年付',
        saveAmount: '省 ${amount}',
        recommended: '人气首选',
    },
    plans: {
        basic: {
            sectionTitle: '您的基础方案',
            featureTitle: '基础方案功能:',
            name: '基础版',
            price: '免费',
            description: '适合个人初次体验，快速了解技术趋势与解答基础问题',
            features: {
                track: '关注少量技术话题动态',
                'ai-qa': '基础 AI 技术问答',
                triz: '体验 TRIZ 创新方案生成',
                report: '体验技术调研报告生成',
            },
        },
        pro: {
            sectionTitle: '您的方案',
            featureTitle: '专业方案功能',
            name: '个人专业版',
            description: '适合资深研发人员，解锁深度分析能力与专业报告导出',
            buttonText: '立即升级',
            featuresHeader: '方案功能:',
            features: {
                proPlanFeatures: '包含免费版所有功能，额外：',
                track: '监控更多技术话题动态',
                'ai-qa': '更充裕的 AI 问答额度',
                triz: '深度应用 TRIZ 攻克技术难题',
                'triz-library': '解锁完整 TRIZ 创新案例库',
                report: '生成深度专业的技术调研报告',
                download: '支持下载/导出报告文档',
            },
        },
        enterprise: {
            name: '企业版',
            price: '联系我们',
            description: '适合研发团队，提供全流程提效工具与企业级安全管控',
            buttonText: '咨询专家',
            featuresHeader: '包含专业版,以及:',
            features: {
                'in-pro-plus': '包含专业版所有功能，额外：',
                'high-frequency': '满足团队规模化的高频使用需求',
                'triz-expert': 'TRIZ 专家模式（支持自定义参数）',
                'full-cycle': '全流程研发提效',
                'company-search': '公司搜索',
                'competitive-landscape': '竞争格局',
                'assess-technical': '评估技术方案可行性',
                'prevent-design-failure': '预防设计失效风险 (DFMEA)',
                'novelty-search': '检查技术创意新颖性 (查新)',
                'patent-disclosure': '辅助撰写专利交底书',
                'security-control': '安全与管理',
                'internal-distribution': '团队内部分发情报简报',
                'strict-file-upload': '严格的文件上传权限控制',
                'private-incognito': '保护隐私的无痕模式',
                'unified-permission': '统一管理团队成员权限',
                'dedicated-support': '专属客户服务支持',
            },
        },
        api: {
            name: 'API',
            price: '定制化',
            description: '将我们的 AI 模型和专有数据无缝集成到您的工作流中',
            buttonText: '了解更多',
            featuresHeader: '包含专业版,以及:',
            features: {
                'unified-ai-data-loop': '统一的 AI 数据闭环，提供可落地的洞察',
                'modular-components': '通过模块化组件和 SDK 实现即时集成',
                'transparent-usage': '透明的使用模式，确保扩展的可预测性',
                'enterprise-infrastructure': '拥有 99.9% SLA 的企业级基础设施',
                'common-connectivity': '支持主流技术栈的通用连接性',
                'proactive-support': '主动式支持与全栈健康监测',
            },
        },
    },
    viewMoreDetails: '查看更多详情',
    error: {
        createPaymentSessionFailed: '创建支付失败,请稍后重试',
    },
};

export const en = {
    title: {
        manageSubscription: 'Manage Subscription',
        pickYourPlan: 'Pick your plan',
        basicUser: 'plans & pricing',
        proUser: 'Manage Subscription',
    },
    subtitle: {
        pickYourPlan: 'Choose the plan that works for you',
        basicUser: 'Autonomy for all. Choose the best plan for you.',
        proUser: 'Manage your subscription',
    },
    recommend: 'Recommend',
    currentPlan: 'Current Plan',
    active: 'ACTIVE',
    canceled: 'Canceled',
    changePlan: 'Change plan',
    cancelPlan: 'Cancel plan',
    resumePlan: 'Resume plan',
    month: 'month',
    year: 'year',
    flashSale: 'Flash Sale 50% OFF',
    billingCycle: {
        monthly: 'Monthly',
        yearly: 'Yearly',
        saveAmount: 'Save ${amount}',
        recommended: 'Most Popular',
    },
    plans: {
        basic: {
            sectionTitle: 'Your Basic Plan',
            featureTitle: 'Basic Plan Features:',
            name: 'Basic',
            price: 'Free',
            description: 'Ideal for individuals to explore tech trends and answer basic questions',
            features: {
                track: 'Track limited technical topics',
                'ai-qa': 'Basic Al technical Q&A',
                triz: 'TRIZ innovation generation',
                report: 'Try technical research reports',
            },
        },
        pro: {
            sectionTitle: 'Your Plan',
            featureTitle: 'Pro Plan Futures',
            name: 'Pro',
            description: 'For senior R&D professionals requiring deep analysis and expert reporting',
            buttonText: 'Subscribe to Pro',
            features: {
                proPlanFeatures: 'Everything in Free, plus:',
                track: 'Track more technical topics',
                'ai-qa': 'Expanded AI Q&A allowance',
                triz: 'Deep TRIZ application for complex problems',
                'triz-library': 'Unlock full TRIZ case library',
                report: 'Generate deep professional research reports',
                download: 'Download/Export report documents',
            },
        },
        enterprise: {
            name: 'Enterprise',
            price: 'Contact us',
            description: 'For R&D teams needing full-cycle efficiency tools and enterprise-grade control',
            buttonText: 'Book a Demo',
            features: {
                'in-pro-plus': 'Everything in pro, plus',
                'high-frequency': 'High-frequency usage for teams',
                'triz-expert': 'TRIZ Expert Mode (Custom parameters)',
                'full-cycle': 'Full-cycle R&D Efficiency',
                'company-search': 'Company Search',
                'competitive-landscape': 'Competitive Landscape',
                'assess-technical': 'Assess technical feasibility',
                'prevent-design-failure': 'Prevent design failure risks (DFMEA)',
                'novelty-search': 'Novelty search & validation',
                'patent-disclosure': 'Patent disclosure drafting assistant',
                'security-control': 'Security & Control',
                'internal-distribution': 'Internal intelligence sharing',
                'strict-file-upload': 'Strict fle upload control',
                'private-incognito': 'Private incognito mode',
                'unified-permission': 'Unified team permission management',
                'dedicated-support': 'Dedicated customer support',
            },
        },
        api: {
            name: 'API',
            price: 'Custom',
            description: 'Seamlessly integrate our AI models and proprietary evidence into your workflows',
            buttonText: 'Learn more',
            features: {
                'unified-ai-data-loop': 'Unified AI-data loop for actionable insights',
                'modular-components': 'Instant integration via modular widgets and SDKs',
                'transparent-usage': 'Predictable scaling with transparent usage models',
                'enterprise-infrastructure': 'Enterprise-grade infrastructure with 99.9% SLA',
                'common-connectivity': 'Universal connectivity across leading tech stacks',
                'proactive-support': 'Proactive support and full-stack health monitoring',
            },
        },
    },
    viewMoreDetails: 'View more details',
    error: {
        createPaymentSessionFailed: 'Failed to create payment, please try again later',
    },
};

export const jp = {
    title: {
        manageSubscription: 'サブスクリプション管理',
        pickYourPlan: 'プランを選択',
        basicUser: 'プランと料金',
        proUser: 'サブスクリプション管理',
    },
    subtitle: {
        pickYourPlan: 'あなたに合ったプランをお選びください',
        basicUser: '必要に応じて選ぶ，最適なプランを見つけよう',
        proUser: 'サブスクリプション管理',
    },
    recommend: 'おすすめ',
    currentPlan: '現在のプラン',
    active: '有効',
    canceled: 'キャンセル済み',
    changePlan: 'プラン変更',
    cancelPlan: 'プランキャンセル',
    resumePlan: 'プラン再開',
    month: '月',
    year: '年',
    flashSale: '閃促 50% OFF',
    billingCycle: {
        monthly: '月払い',
        yearly: '年払い',
        saveAmount: '${amount} お得',
        recommended: '最も選ばれている',
    },
    plans: {
        basic: {
            sectionTitle: 'ベーシックプラン',
            featureTitle: 'ベーシックプラン機能:',
            name: 'ベーシック',
            price: '無料',
            description: '技術トレンドの探索や基本的な質問への回答を行いたい個人に最適です',
            features: {
                track: '限定的な技術トピックの追跡',
                'ai-qa': '基本的なAI技術Q&A',
                triz: 'TRIZによるイノベーション創出',
                report: '技術調査レポートの試用',
            },
        },
        pro: {
            sectionTitle: 'プロプラン',
            featureTitle: 'プロプラン機能',
            name: 'プロ',
            description: '深い分析と専門的なレポートを必要とするシニアR&Dプロフェッショナル向け',
            buttonText: 'Proに登録する',
            featuresHeader: 'プラン機能:',
            features: {
                proPlanFeatures: 'Basicプランの全機能に加え：',
                track: 'より多くの技術トピックの追跡',
                'ai-qa': 'AI Q&Aの利用枠拡大',
                triz: '複雑な問題へのTRIZの深い適用',
                'triz-library': 'TRIZ事例ライブラリの全機能解放',
                report: '専門的な深掘り調査レポートの作成',
                download: 'レポート文書のダウンロード/エクスポート',
            },
        },
        enterprise: {
            name: 'エンタープライズ',
            price: 'お問い合わせ',
            description: 'ライフサイクル全体の効率化ツールと企業レベルの管理を必要とするR&Dチーム向け',
            buttonText: 'デモを予約する',
            featuresHeader: 'プロ版に加えて:',
            features: {
                'in-pro-plus': 'Proプランの全機能に加え：',
                'high-frequency': 'チーム向けの頻繁な利用',
                'triz-expert': 'TRIZエキスパートモード（カスタムパラメータ）',
                'full-cycle': 'R&Dライフサイクル全体の効率化：',
                'company-search': '企業検索',
                'competitive-landscape': '競合状況分析',
                'assess-technical': '技術的実現可能性の評価',
                'prevent-design-failure': '設計失敗リスクの防止 (DFMEA)',
                'novelty-search': '新規性調査と検証',
                'patent-disclosure': '特許開示ドラフト作成アシスタント',
                'security-control': 'セキュリティと管理：',
                'internal-distribution': '内部インテリジェンスの共有',
                'strict-file-upload': '厳格なファイルアップロード管理',
                'private-incognito': 'プライベート・シークレットモード',
                'unified-permission': '統合されたチーム権限管理',
                'dedicated-support': '専任カスタマーサポート',
            },
        },
        api: {
            name: 'API',
            price: 'カスタム',
            description: '当社のAIモデルと独自の根拠資料をワークフローにシームレスに統合します',
            buttonText: '詳しく見る',
            featuresHeader: 'プロ版に加えて:',
            features: {
                'unified-ai-data-loop': '実用的なインサイトを得るための統合されたAIデータループ',
                'modular-components': 'モジュール化されたウィジェットとSDKによる即時統合',
                'transparent-usage': '透明性のある利用モデルによる予測可能なスケーリング',
                'enterprise-infrastructure': '99.9%のSLAを保証する企業向けインフラストラクチャ',
                'common-connectivity': '主要な技術スタックにわたるユニバーサルな接続性',
                'proactive-support': 'プロアクティブなサポートとフルスタックのヘルスモニタリング',
            },
        },
    },
    viewMoreDetails: '詳細を見る',
    error: {
        createPaymentSessionFailed: '支払いの作成に失敗しました,後でもう一度お試しください',
    },
};

export const tw = {
    title: {
        manageSubscription: '管理訂閱',
        pickYourPlan: '選擇方案',
        basicUser: '定價方案',
        proUser: '管理訂閱',
    },
    subtitle: {
        pickYourPlan: '選擇適合您的方案',
        basicUser: '解鎖專業功能按需選擇，找到最適合你的方案',
        proUser: '管理您的訂閱',
    },
    recommend: '推薦',
    currentPlan: '目前方案',
    active: '已啟用',
    canceled: '已取消',
    changePlan: '切換方案',
    cancelPlan: '取消方案',
    resumePlan: '恢復方案',
    month: '月',
    year: '年',
    flashSale: '閃促 50% OFF',
    billingCycle: {
        monthly: '月付',
        yearly: '年付',
        saveAmount: '省 ${amount}',
        recommended: '人氣首選',
    },
    plans: {
        basic: {
            sectionTitle: '您的基礎方案',
            featureTitle: '基礎方案功能:',
            name: '基礎版',
            price: '免費',
            description: '適合個人初次體驗，快速了解技術趨勢與解答基礎問題',
            features: {
                track: '關注少量技術話題動態',
                'ai-qa': '基礎 AI 技術問答',
                triz: '體驗 TRIZ 創新方案生成',
                report: '體驗技術調研報告生成',
            },
        },
        pro: {
            sectionTitle: '您的方案',
            featureTitle: '專業方案功能',
            name: '個人專業版',
            description: '適合資深研發人員，解鎖深度分析能力與專業報告導出',
            buttonText: '立即升級',
            featuresHeader: '方案功能:',
            features: {
                proPlanFeatures: '包含免費版所有功能，額外：',
                track: '監控更多技術話題動態',
                'ai-qa': '更充裕的 AI 問答額度',
                triz: '深度應用 TRIZ 攻克技術難題',
                'triz-library': '解鎖完整 TRIZ 創新案例庫',
                report: '生成深度專業的技術調研報告',
                download: '支援下載 / 導出報告文檔',
            },
        },
        enterprise: {
            name: '企業版',
            price: '聯繫我們',
            description: '適合研發團隊，提供全流程提效工具與企業級安全管控',
            buttonText: '諮詢專家',
            featuresHeader: '包含專業版,以及:',
            features: {
                'in-pro-plus': '包含專業版所有功能，額外：',
                'high-frequency': '滿足團隊規模化的高頻使用需求',
                'triz-expert': 'TRIZ 專家模式（支援自定義參數）',
                'full-cycle': '全流程研發提效',
                'company-search': '公司搜索',
                'competitive-landscape': '競爭格局',
                'assess-technical': '評估技術方案可行性',
                'prevent-design-failure': '預防設計失效風險 (DFMEA)',
                'novelty-search': '檢查技術創意新穎性（查新）',
                'patent-disclosure': '輔助撰寫專利交底書',
                'security-control': '安全與管理',
                'internal-distribution': '團隊內部分發情報簡報',
                'strict-file-upload': '嚴格的文件上傳權限控制',
                'private-incognito': '保護隱私的無痕模式',
                'unified-permission': '統一管理團隊成員權限',
                'dedicated-support': '專屬客戶服務支持',
            },
        },
        api: {
            name: 'API',
            price: '客製化',
            description: '將我們的 AI 模型和專有資料無縫集成到您的工作流程中',
            buttonText: '瞭解更多',
            featuresHeader: '包含專業版,以及:',
            features: {
                'unified-ai-data-loop': '統一的 AI 數據閉環，提供可落地的洞察',
                'modular-components': '透過模組化組件和 SDK 實現即時集成',
                'transparent-usage': '透明的使用模式，確保擴展的可預測性',
                'enterprise-infrastructure': '擁有 99.9% SLA 的企業級基礎設施',
                'common-connectivity': '支援主流技術棧的通用連接性',
                'proactive-support': '主動式支持與全線健康監測',
            },
        },
    },
    viewMoreDetails: '查看更多详情',
    error: {
        createPaymentSessionFailed: '创建支付失败,请稍后重试',
    },
};
